import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import tw from 'twin.macro';

import { getStep } from '@/app/store/slices/app';
import { wsStatuses } from '@/app/utils/constants';
// import gif from '@/assets/yB.gif';
import { StepContentWrapper, SubTitle, Title } from '@/components';

function PrepaidWaitingPage() {
  const step = useSelector(getStep);
  const navigate = useNavigate();

  useEffect(() => {
    step === wsStatuses.finished && navigate('/success');
  }, [step]);
  // const { data } = usePrepaidGetStatusQuery(null, { pollingInterval: 10000 });
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   if (data?.data?.pan_card || String(data?.data?.status).toLowerCase() === 'finished') {
  //     navigate('/prepaid-card/pp-success');
  //   }
  //   if (step !== data?.data?.step) {
  //     setStep(data?.data?.step);
  //   }
  //   if (String(data?.data?.status).toLowerCase() === 'rejected') {
  //     dispatch(
  //       setCustomError({
  //         code: 'pp_rejected',
  //         description: 'Ваш платеж был отклонен. Для оформления Prepaid карты вам необходимо подать заявку заново'
  //       })
  //     );
  //     navigate('/error');
  //   }
  //   if (String(data?.data?.status).toLowerCase() === 'canceled') {
  //     dispatch(
  //       setCustomError({
  //         code: 'pp_rejected',
  //         description: 'Ваша заявка была отменена. Для оформления Prepaid карты вам необходимо подать заявку заново'
  //       })
  //     );
  //     navigate('/error');
  //   }
  // }, [data]);

  return (
    <StepContentWrapper twStyles={tw`text-center`}>
      <div tw='max-w-[416px] mx-auto my-[48px] flex flex-col gap-10 items-center '>
        <ClipLoader color='rgb(42, 134, 64)' size={70} speedMultiplier={0.6} />
        {/* <img src={gif} alt='' /> */}
        {step === wsStatuses.creating_card && (
          <div>
            <Title text={<span>Идет процесс создания карточки</span>} variant={'bold'} />
            <SubTitle
              twStyle={tw`sm:text-s18 text-s14`}
              text={
                <span>
                  <br /> Процесс займет не более 5 минут. <br /> Пожалуйста, подождите...
                </span>
              }
            />
          </div>
        )}
        {step === wsStatuses.payment && (
          <div>
            <Title text={<span>Идет обработка платежа</span>} variant={'bold'} />
            <SubTitle
              twStyle={tw`sm:text-s18 text-s14`}
              text={
                <span>
                  <br />
                  Пожалуйста, подождите...
                </span>
              }
            />
          </div>
        )}
      </div>
    </StepContentWrapper>
  );
}

export default PrepaidWaitingPage;
